<div class="w-100">
  <h3>Überleitung erfolgt an
  </h3>

    <mat-form-field class="w-100" appearance="fill" *ngIf="!loadingFirstPage; else loading">
      <mat-label>Zielberater</mat-label>
      <mat-select [value]="preferredAgent" (selectionChange)="select($event.value)">
        <mat-option *ngFor="let cooperation of cooperations" [value]="cooperation">
          {{cooperation._embedded.employee.lastName}}, {{cooperation._embedded.employee.firstName}} ({{cooperation._embedded.office.name}})
        </mat-option>
      </mat-select>
      <mat-progress-bar color="primary" mode="indeterminate" class="input-progress-bar" *ngIf="loadingMorePages"></mat-progress-bar>
      <mat-error *ngIf="!preferredAgent">Pflichtfeld</mat-error>
    </mat-form-field>
    <ng-template #loading>
      <mat-form-field appearance="fill" style="margin-bottom: 0" class="w-100">
        <mat-label>Berater werden geladen ...</mat-label>
        <mat-select disabled="true">
          <mat-option></mat-option>
        </mat-select>
        <mat-progress-bar color="primary" mode="indeterminate" class="input-progress-bar"></mat-progress-bar>
      </mat-form-field>
    </ng-template>
  </div>





